export class BlockchainAddress {
  idBlockchainAddress: number;
  idBlockchain: number;
  formatName: string;
  prefix: string;
  regexPattern: string;
  minLength: number;
  maxLength: number;
  checksumAlgorithm: string;
  hasMemoTag: boolean;
  description: string | null;
  locked: boolean;

  constructor(
    idBlockchainAddress: number,
    idBlockchain: number,
    formatName: string,
    prefix: string,
    regexPattern: string,
    minLength: number,
    maxLength: number,
    checksumAlgorithm: string,
    hasMemoTag: boolean,
    description: string | null,
    locked: boolean,
  ) {
    this.idBlockchainAddress = idBlockchainAddress;
    this.idBlockchain = idBlockchain;
    this.formatName = formatName;
    this.prefix = prefix;
    this.regexPattern = regexPattern;
    this.minLength = minLength;
    this.maxLength = maxLength;
    this.checksumAlgorithm = checksumAlgorithm;
    this.hasMemoTag = hasMemoTag;
    this.description = description;
    this.locked = locked;
  }

  static fromRaw(raw: any): BlockchainAddress {
    return new BlockchainAddress(
      Number(raw.idBlockchainAddress ?? raw.id_blockchain_address),
      Number(raw.idBlockchain ?? raw.id_blockchain),
      String(raw.formatName ?? raw.format_name),
      String(raw.prefix),
      String(raw.regexPattern ?? raw.regex_pattern),
      Number(raw.minLength ?? raw.min_length),
      Number(raw.maxLength ?? raw.max_length),
      String(raw.checksumAlgorithm ?? raw.checksum_algorithm),
      Boolean(raw.hasMemoTag ?? raw.has_memo_tag),
      raw.description === null ? null : String(raw.description),
      Boolean(raw.locked),
    );
  }

  clone(): BlockchainAddress {
    return new BlockchainAddress(
      this.idBlockchainAddress,
      this.idBlockchain,
      this.formatName,
      this.prefix,
      this.regexPattern,
      this.minLength,
      this.maxLength,
      this.checksumAlgorithm,
      this.hasMemoTag,
      this.description,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idBlockchain: this.idBlockchain,
      formatName: this.formatName,
      prefix: this.prefix,
      regexPattern: this.regexPattern,
      minLength: this.minLength,
      maxLength: this.maxLength,
      checksumAlgorithm: this.checksumAlgorithm,
      hasMemoTag: this.hasMemoTag,
      description: this.description,
    };
    if (this.idBlockchainAddress !== 0) {
      payload.idBlockchainAddress = this.idBlockchainAddress;
    }
    return payload;
  }
}
